import {createSelector} from '@reduxjs/toolkit';

export const pobReportStateSelector = {
  getPriorityProducts: () => {
    return createSelector(
      [(state: any) => state.pobManagement.priorityProducts],
      priorityProducts => priorityProducts,
    );
  },
  getPriorityProductsLoading: () => {
    return createSelector(
      [(state: any) => state.pobManagement.priorityProductsLoading],
      priorityProductsLoading => priorityProductsLoading,
    );
  },
  getAverageSalePrices: () => {
    return createSelector(
      [(state: any) => state.pobManagement.averageSalePrices],
      averageSalePrices => averageSalePrices,
    );
  },
  getAverageSalePricesLoading: () => {
    return createSelector(
      [(state: any) => state.pobManagement.averageSalePricesLoading],
      averageSalePricesLoading => averageSalePricesLoading,
    );
  },
  getActiveSkuData: () => {
    return createSelector(
      [(state: any) => state.pobManagement.activeSkuData],
      activeSkuData => activeSkuData,
    );
  },
  getActiveSkuDataLoading: () => {
    return createSelector(
      [(state: any) => state.pobManagement.activeSkuDataLoading],
      activeSkuDataLoading => activeSkuDataLoading,
    );
  },
};
